define([
	"dojo/_base/declare",
	"./_RevisedGapMixin",
	"./Revised"
], function(declare,_RevisedGapMixin,Revised) {

	return declare([Revised,_RevisedGapMixin], {
		_getDiff: function(/*Number*/value, /*Number*/target) {
			// summary: return value since it is already the difference
			return value;
		}
	});
});